export default __webpack_public_path__ + "static/10years-b788cfc8679f552430f9d0dcab3046f3.svg";